export const SLIDER_ITEM_THUMBNAIL = 'thumbnail_portrait';
export const CAROUSEL_ITEM_THUMBNAIL = 'poster_landscape';
